<template>
    <v-layout>
        <v-btn
                small
                v-if="$routerHistory.hasPrevious()"
                :to="{ path: $routerHistory.previous().path }"
        >
            <v-icon>arrow_back</v-icon>
        </v-btn>

        <v-spacer><p class="title text-md-center">{{ titulo }}</p></v-spacer>
    </v-layout>
</template>

<script>
    export default {
        data: () => ({

        }),
        computed : {
            titulo : function(){
                return this.$store.getters.getSectionTitle;
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/shared/BackMenuComponent.vue